module.exports = __webpack_public_path__ + "static/anthony-rendon-652b77a897040c12ee7afa6add892d67.jpg";